import { Pipe, PipeTransform } from "@angular/core";
import { AccountLanguage } from "@interfaces/HttpClient/AccountApiPublicModels";
import { TranslationService } from "@services/translation.service";
@Pipe({
	name: "languageTranslation",
	pure: false
})
export class LanguageTranslationPipe implements PipeTransform {

	constructor(private translationService: TranslationService) { }
	transform(key: string, language: AccountLanguage): string {
		this.translationService.loadLanguage(language)
		return this.translationService.getByKeyAndLanguage(key, language);
	}
}